export const vpnService = {
  openvpn_active: "openvpn_active",
  for_windows: "for_windows",
  for_non_windows: "for_non_windows",
  for_smart_phone: "for_smart_phone",
  link_windows: "link_windows",
  link_macosx: "link_macosx",
  link_iphone: "link_iphone",
  link_andriod: "link_andriod",
  openvpn_tun_service_port: "openvpn_tun_service_port",
  openvpn_service_port: "openvpn_service_port",
};

export default vpnService;
